import React, { useEffect, useRef } from 'react';
import './AdBanner.css';

function AdBanner() {
  const adRef = useRef(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    // Prevent double initialization (React StrictMode causes double renders in dev)
    if (initializedRef.current) return;
    
    // Check cookie consent and initialize ads
    const checkConsentAndInit = () => {
      const consent = localStorage.getItem('cookieConsent');
      // Only initialize if consent is accepted (not rejected or not set)
      if (consent !== 'accepted') {
        return;
      }
      
      // Wait for adsbygoogle script to load and ensure element is visible
      const initAd = () => {
        if (!adRef.current) {
          setTimeout(initAd, 100);
          return;
        }

        if (window.adsbygoogle && !initializedRef.current) {
          // Check if ad is already initialized
          if (adRef.current.getAttribute('data-adsbygoogle-status')) {
            initializedRef.current = true;
            return;
          }
          
          try {
            initializedRef.current = true;
            (window.adsbygoogle = window.adsbygoogle || []).push({});
            console.log('AdBanner: Ad initialization triggered');
          } catch (e) {
            console.error('Error loading ad:', e);
            initializedRef.current = false; // Allow retry on error
          }
        } else if (!window.adsbygoogle) {
          // Retry after a short delay if script isn't loaded yet
          setTimeout(initAd, 100);
        }
      };

      // Small delay to ensure DOM is ready
      setTimeout(initAd, 100);
    };

    // Check consent immediately
    checkConsentAndInit();
    
    // Listen for custom event when consent is accepted
    const handleConsentAccepted = () => {
      if (!initializedRef.current) {
        checkConsentAndInit();
      }
    };
    window.addEventListener('cookieConsentAccepted', handleConsentAccepted);
    
    // Listen for storage events (when consent is given in another tab/window)
    const handleStorageChange = (e) => {
      if (e.key === 'cookieConsent' && e.newValue === 'accepted') {
        checkConsentAndInit();
      }
    };
    window.addEventListener('storage', handleStorageChange);
    
    // Also check periodically in case consent was given in same window
    const consentCheckInterval = setInterval(() => {
      const consent = localStorage.getItem('cookieConsent');
      if (consent === 'accepted' && !initializedRef.current) {
        checkConsentAndInit();
      }
    }, 500);

    return () => {
      window.removeEventListener('cookieConsentAccepted', handleConsentAccepted);
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(consentCheckInterval);
    };
  }, []);

  return (
    <div className="ad-banner-wrapper">
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block', width: '100%', maxWidth: '728px', margin: '0 auto', minHeight: '90px' }}
        data-ad-client="ca-pub-5796274955755003"
        data-ad-slot={process.env.REACT_APP_ADS_BANNER_SLOT || "9477900031"}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}

export default AdBanner;

